module.exports = __webpack_public_path__ + "img/fabric.cb7185ea.png";